module.exports = __webpack_public_path__ + "images/berufsunfaehigkeit.png?13174b38e688abc5c9c171688fd650ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/berufsunfaehigkeit.png
// module id = gkKk
// module chunks = 0